import { defineStore } from 'pinia'
import { loginApi, verifyApi, changePasswordApi, refreshApi } from './loginApi'
import { groupEditRoles } from '@/constants/permissions'

export default defineStore('auth Store', {
  state: () => ({
    accessToken: localStorage.getItem('accessToken') || '',
    refreshToken: localStorage.getItem('refreshToken') || '',
    user: {},
  }),
  getters: {
    // 目前角色可否編輯該路由分組（傳入 meta.group），SuperAdmin 一律可編輯
    canEditGroup: (state) => (group) =>
      state.user.role === 'SuperAdmin' || (groupEditRoles[group] || []).includes(state.user.role),
  },
  actions: {
    // 登入：token 只放 state（記憶體）
    async login(payload) {
      const res = await loginApi(payload)
      this.setTokens(res.data)
    },
    // 取得使用者資訊（角色、是否須改密碼）
    async verify() {
      const res = await verifyApi()
      this.user = res.data
    },
    // 改密碼：換新 token → 寫入 localStorage → 重新 verify
    async changePassword(payload) {
      const res = await changePasswordApi(payload)
      this.setTokens(res.data)
      this.saveTokens()
      await this.verify()
    },
    // 更新 state 裡的 token
    setTokens(data) {
      this.accessToken = data.accessToken
      this.refreshToken = data.refreshToken
    },
    // 把 state 裡的 token 寫入 localStorage
    saveTokens() {
      localStorage.setItem('accessToken', this.accessToken)
      localStorage.setItem('refreshToken', this.refreshToken)
    },
    // 換發 token
    async refresh() {
      const res = await refreshApi({ refreshToken: this.refreshToken })
      this.setTokens(res.data)

      // 原本有存進 localStorage 的才更新，登入流程中（只在記憶體）的不寫入
      if (localStorage.getItem('accessToken')) {
        this.saveTokens()
      }
    },
    // 清除 token 與使用者資訊
    clearTokens() {
      this.accessToken = ''
      this.refreshToken = ''
      this.user = {}
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
    },
  },
})